import { render, staticRenderFns } from "./DealerDetail.vue?vue&type=template&id=308d5b58&"
import script from "./DealerDetail.vue?vue&type=script&lang=ts&"
export * from "./DealerDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DealerDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports